import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getOptimizedImageUrl } from '../../lib/cloudinary';
import { HOME_HERO_VIDEO_PATH } from '../../seo/homeHeroVideoSchema';
import './TopHero.css';

const BACKGROUND_IMG = '/Images/hero-warehouse-worker.jpg';

export default function TopHero() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <>
      <section className="top-hero-section" aria-label="Welcome to Pick Pack Pro">
        <div 
          className="top-hero-bg" 
          style={{ backgroundImage: `url(${getOptimizedImageUrl(BACKGROUND_IMG, { width: 1920, fit: 'limit' })})` }}
        />
        <div className="top-hero-overlay" />

        <div className="top-hero-container">
          <div className="top-hero-content">
            <div className="top-hero-eyebrow">
              <span className="eyebrow-line"></span>
              ECOMMERCE FULFILMENT, DONE RIGHT
            </div>
            
            <h1 className="top-hero-title">
          Expert Pick and Pack &amp;<br /> Fulfilment Services <span className="text-blue">UK</span>
        </h1>
            
                    <p className="top-hero-subtitle" style={{ fontSize: '1.05rem', lineHeight: '1.6', marginBottom: '24px', maxWidth: '540px' }}>
          <strong style={{ color: '#0f172a' }}>Bottom Line:</strong> Pick Pack Pro is a specialist UK 3PL delivering 99.9% accurate pick and pack, compliant Amazon FBA prep, and same-day multi-channel solutions for ambitious brands. From our Milton Keynes hub, we handle the logistics so you can focus on scaling.
        </p>
            
            <div className="top-hero-actions">
              <Link to="/contact-fulfillment-services" className="btn-primary">
                Get a fulfilment quote <span className="arrow">→</span>
              </Link>
              <button className="btn-video" onClick={() => setIsVideoOpen(true)}>
                <span className="play-icon">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </span>
                Watch our video
              </button>
            </div>
          </div>
          
          </div>
      </section>

      {/* Video Popup Modal */}
      {isVideoOpen && (
        <div className="video-modal-overlay" onClick={() => setIsVideoOpen(false)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-video-btn" onClick={() => setIsVideoOpen(false)} aria-label="Close video">✕</button>
            <video 
              controls 
              autoPlay 
              className="popup-video-element"
              src={HOME_HERO_VIDEO_PATH}
            />
          </div>
        </div>
      )}
    </>
  );
}

